import { render, staticRenderFns } from "./ItemOrderForFlatRate.vue?vue&type=template&id=42d50be7&lang=pug&"
import script from "./ItemOrderForFlatRate.vue?vue&type=script&lang=ts&"
export * from "./ItemOrderForFlatRate.vue?vue&type=script&lang=ts&"
import style0 from "./ItemOrderForFlatRate.vue?vue&type=style&index=0&id=42d50be7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports